<div class="app-container" [class.dialog-container]="hasOpenDialog$ | async">
  <router-outlet></router-outlet>
  <div *ngIf="hasBackgroundPattern$ | async" class="bg-pattern">
    <img src="assets/images/background.svg" alt="background pattern" />
  </div>
</div>
